/* Reveal beim Scrollen, Kopfzeilen-Verkleinerung, Bild-Einblendung und
   Hero-Parallaxe — Verhalten wie in der Vorlage (WernerArt.dc.html). */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  /* Bilder kommen unscharf herein und werden beim Laden scharf.
     Der Ruhezustandsfilter der Kachel bleibt dabei erhalten. */
  function blurIn() {
    document.querySelectorAll('[data-blur]').forEach(function (el) {
      if (el._waBlurWired) return;
      el._waBlurWired = true;

      var base = el.getAttribute('data-base-filter') || 'none';

      function show() {
        el.style.opacity = '1';
        el.style.transform = 'scale(1)';
        el.style.filter = base;
      }

      if (reduceMotion || (el.complete && el.naturalWidth)) {
        show();
        return;
      }

      el.style.opacity = '0';
      el.style.transform = 'scale(1.03)';
      el.style.filter = (base === 'none' ? '' : base + ' ') + 'blur(14px)';
      el.style.transition = 'opacity .8s ease, transform 1.1s cubic-bezier(.16,1,.3,1), filter .8s ease';
      el.addEventListener('load', show, { once: true });
      el.addEventListener('error', show, { once: true });
    });
  }

  /* Ab 40px Scrollhöhe wird die Kopfzeile flacher. */
  function navShrink() {
    var nav = document.querySelector('[data-wa-nav]');
    if (!nav) return;

    var frame = null;

    function apply() {
      frame = null;
      if ((window.scrollY || 0) > 40) {
        nav.setAttribute('data-scrolled', '1');
      } else {
        nav.removeAttribute('data-scrolled');
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (frame === null) frame = window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    apply();
  }

  function reveal() {
    var elements = document.querySelectorAll('[data-reveal]:not([data-revealed])');
    if (!elements.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.setAttribute('data-revealed', '1');
      });
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-revealed', '1');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
      );
    }

    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* Kann der Browser Scroll-Zeitachsen, macht wa-sections.css die Parallaxe
     im Compositor — das Skript hält sich dann ganz heraus. */
  var cssParallax =
    window.CSS && typeof window.CSS.supports === 'function' && window.CSS.supports('animation-timeline', 'scroll()');

  function parallax() {
    if (cssParallax || reduceMotion) return;

    var image = document.querySelector('[data-wa-parallax]');
    // Beim Wechsel einer Section läuft parallax() erneut. Ohne diese Sperre
    // hinge an jedem Durchlauf ein weiterer Scroll-Horcher am Fenster.
    if (!image || image._waParallaxBound) return;
    image._waParallaxBound = true;

    var hero = image.closest('.wa-hero') || image.parentElement;
    var intensity = window.waTheme && typeof window.waTheme.parallax === 'number' ? window.waTheme.parallax : 0.4;
    var frame = null;
    var last = null;

    function apply() {
      frame = null;

      // Über die Höhe des Hero hinaus ist das Bild fort — dann nicht weiter
      // rechnen und vor allem nicht weiter schreiben.
      var limit = hero ? hero.offsetHeight : window.innerHeight;
      var offset = Math.min(window.scrollY || 0, limit) * intensity;
      if (offset === last) return;
      last = offset;

      image.style.transform = 'translate3d(0, ' + offset + 'px, 0) scale(1.08)';
    }

    window.addEventListener(
      'scroll',
      function () {
        if (frame === null) frame = window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    apply();
  }

  /* Waagerechte Reihen (Werkgruppen, Teaser) — Bauteil aus der Vorlage:
     unter der Reihe steht eine Haarlinie, auf der ein Balken die Position
     anzeigt. Am Schreibtisch schiebt zusätzlich das Mausrad, und die Reihe
     lässt sich mit gedrückter Maustaste ziehen. */
  function rails() {
    document.querySelectorAll('[data-wa-rail]').forEach(function (rail) {
      // Schon gebunden: nur neu messen. Die Werkgruppen kommen später dazu.
      if (rail.dataset.waRailBound === '1') {
        if (rail._waRailSync) rail._waRailSync();
        return;
      }
      rail.dataset.waRailBound = '1';

      var name = rail.getAttribute('data-wa-rail');
      var track = document.querySelector('[data-wa-rail-track="' + name + '"]');
      var bar = document.querySelector('[data-wa-rail-bar="' + name + '"]');

      function overflow() {
        return rail.scrollWidth - rail.clientWidth;
      }

      function sync() {
        var max = overflow();

        if (track) track.hidden = max < 2;
        if (!bar || max < 2) return;

        var ratio = rail.clientWidth / rail.scrollWidth;
        var progress = rail.scrollLeft / max;
        bar.style.width = ratio * 100 + '%';
        bar.style.transform = 'translateX(' + progress * (100 / ratio - 100) + '%)';
      }

      rail._waRailSync = sync;
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      // Senkrechtes Rad in waagerechtes Schieben übersetzen — aber nur, solange
      // die Reihe noch Weg hat, sonst scrollt die Seite nicht mehr weiter.
      rail.addEventListener(
        'wheel',
        function (event) {
          var max = overflow();
          if (max < 2) return;
          if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

          var next = rail.scrollLeft + event.deltaY;
          if (next < 0 || next > max) return;

          event.preventDefault();
          rail.scrollLeft = next;
        },
        { passive: false }
      );

      // Ziehen mit der Maus.
      var dragging = false;
      var startX = 0;
      var startLeft = 0;

      rail.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || overflow() < 2) return;
        dragging = true;
        startX = event.clientX;
        startLeft = rail.scrollLeft;
      });

      rail.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        var moved = startX - event.clientX;
        if (Math.abs(moved) > 3) rail.setAttribute('data-dragging', '1');
        rail.scrollLeft = startLeft + moved;
      });

      function endDrag() {
        dragging = false;
        // Erst im nächsten Takt lösen, sonst löst das Loslassen einen Klick aus.
        window.setTimeout(function () {
          rail.removeAttribute('data-dragging');
        }, 0);
      }

      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('pointerleave', endDrag);

      // Ein Klick, der eigentlich ein Ziehen war, darf nicht filtern.
      rail.addEventListener(
        'click',
        function (event) {
          if (rail.hasAttribute('data-dragging')) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );

      sync();
    });
  }

  /* Menü auf schmalen Schirmen — dunkle Fläche über der ganzen Seite. */
  function menu() {
    var panel = document.querySelector('[data-wa-menu]');
    var open = document.querySelector('[data-wa-menu-open]');
    var close = document.querySelector('[data-wa-menu-close]');
    if (!panel || !open || panel.dataset.waBound === '1') return;
    panel.dataset.waBound = '1';

    // Die Einträge steigen gestaffelt auf und ziehen sich gestaffelt zurück.
    var items = [].slice.call(panel.querySelectorAll('.wa-menu__item'));
    items.forEach(function (item, i) {
      item.style.setProperty('--wa-menu-i', i);
    });

    var closeTimer = null;

    function show() {
      window.clearTimeout(closeTimer);
      panel.removeAttribute('data-closing');
      panel.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function hide() {
      if (panel.hidden || panel.hasAttribute('data-closing')) return;

      open.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';

      if (reduceMotion) {
        panel.hidden = true;
        return;
      }

      // Erst ausblenden lassen, dann aus dem Bild nehmen — sonst reißt es ab.
      panel.setAttribute('data-closing', '1');
      closeTimer = window.setTimeout(function () {
        panel.hidden = true;
        panel.removeAttribute('data-closing');
      }, 320);
    }

    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) hide();
    });
  }

  reveal();
  blurIn();
  navShrink();
  menu();
  rails();
  parallax();

  document.addEventListener('shopify:section:load', function () {
    reveal();
    blurIn();
    navShrink();
    menu();
    rails();
    parallax();
  });

  // Die Werkgruppen entstehen erst im Skript der Galerie — dann neu messen.
  document.addEventListener('wa:rails', rails);
})();
